var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-button',{staticClass:"btn btn-label btn-primary float-right",attrs:{"disabled":_vm.isButtonDisabled,"id":"btn_search","variant":"primary"},on:{"click":_vm.exportToExcel}},[_c('i',{staticClass:"bx bx-export label-icon"}),_vm._v("Export to Excel")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }